// Core
import { generatePath as routerGeneratePath } from 'react-router';

const baseUrl = `/`;

export const host = location.host.includes('odev.io') || location.host.includes('dev.tat.ua')
    ? 'http://tat.fish.dev05.odev.io'
    : `${location.protocol}//${location.host}`;

export const book = Object.freeze({
    mainPage:          `${baseUrl}`,
    searchPage:        `${baseUrl}search`,
    hotelPage:         `${baseUrl}:countryCode/:resortCode/:hotelId(\\d+)-:hotelCode/:offerId(\\d+)?`,
    comparePage:       `${baseUrl}compare`,
    toursPage:         `${baseUrl}tours`,
    playgroundPage:    `${baseUrl}playground`,
    countriesPage:     `${baseUrl}countries`,
    countryPage:       `${baseUrl}countries/:countryCode/:section*`,
    countrySearchPage: `${baseUrl}countries/:countryCode/search_tours`,
});

export const createUrl = (scheme, ...params) => {
    return params.reduce((url, param) => url.replace(/:[^:/-]+/, param), scheme);
};

export const generatePath = (...args) => {
    return `${host}${routerGeneratePath(...args)}`;
};
